import { render, staticRenderFns } from "./MusicWishlist.vue?vue&type=template&id=d4a21a88"
import script from "./MusicWishlist.vue?vue&type=script&lang=js"
export * from "./MusicWishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports